<template>
  <div class="partner-contact-bd">
    <div class="partner-contact-wrap">
      <div class="table-bd">
        <div class="contact-title" style="margin:16px 0px;" v-if="funcView.partner_detail_add_contact">
          <el-button type="primary" icon="el-icon-plus" @click="addContact()">{{
            $t('crm_partner-contact.xin_zeng_lian_xi_ren')
          }}</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="addBatchContact()">{{ $t('crm_partner-contact.plxzlxr') }}</el-button>
        </div>
        <custom-table
          :data="contactList"
          :loading="isLoading"
          :column="tableColumn"
          :slots="['action']"
          @filter="filterChange"
          @sort="sortChange"
        >
          <template v-slot:action="scope">
            <span></span>
            <el-button
              type="text"
              size="mini"
              v-if="funcView.partner_detail_edit_contact"
              @click="editContact(scope.row)"
            >{{$t('Common.com_edit')}}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="funcView.partner_detail_delete_contact"
              @click="deleteContact(scope.row.contactId)"
            >{{$t('Common.com_delete')}}</el-button>
          </template>
        </custom-table>
      </div>
    </div>
    <company-contacts-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :data="dialogData"
      @close="dialogVisible = false"
      @success="getContactList"
    >
    </company-contacts-dialog>
    <company-contactsBatch-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getContactList"
    >
    </company-contactsBatch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import companyContactsDialog from './partner_contacts_dialog';
import companyContactsBatchDialog from './partner_contactsBatch_dialog';

export default {
  components: {
    companyContactsDialog, companyContactsBatchDialog
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String,
    partnerOrgId: String,

  },
  data() {
    return {
      tableCode: 'company_contact',
      // 合同类型
      // 操作
      visibleSet: '',
      dialogSetData: {},
      contactList: [],
      // 联系人弹窗
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      // 批量添加联系人弹窗
      dialogVisible1: false,
      dialogModel1: {},
    };
  },

  mounted() {
    this.getTableColumn();
    this.getContactList();
    this.getFuncView('/customer/renterDetail');
  },
  methods: {
    getContactList: function () {
      if (!this.partnerId) {
        return;
      }
      this.$getJSON(apis.partnerContact, {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      }).then((res) => {
        this.contactList = res.data;
      });
    },
    // 编辑联系人
    editContact(item) {
      const title = this.$t('crm_partner-contact.bian_ji_lian_xi_ren');
      this.dialogData = item;
      this.dialogModel.title = title;
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
      // this.getPartnerContact()
    },
    // 新增联系人
    addContact() {
      const title = this.$t('crm_partner-contact.xin_zeng_lian_xi_ren');
      this.dialogData.partnerId = this.partnerId;
      this.dialogData.partnerOrgId = this.partnerOrgId;
      this.dialogModel.title = title;
      this.dialogModel.type = 'add';
      this.dialogVisible = true;
      // this.getPartnerContact()
    },
    // 批量新增联系人
    addBatchContact() {
      const title = this.$t('crm_partner-contact.xuan_ze_yong_hu');
      this.dialogModel1.partnerId = this.partnerId;
      this.dialogModel1.partnerOrgId = this.partnerOrgId;
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'add';
      this.dialogVisible1 = true;
      // this.getPartnerContact()
    },
    deleteContact: function (contactId) {
      const tips = this.$t('crm_partner-contact.nqdysclxrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`).then(
            () => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContactList();
            }
          );
        })
        .catch(() => {});
    },
  }
};
</script>

<style lang="scss">
@import "style/colors.scss";
.partner-contact-bd {
  // height: 100%;
  // display: flex;
  // flex-direction: column;
  .partner-contact-wrap {
    // flex: 1;
    // height: 0;
    // display: flex;
    // flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    // background-color: #ffffff;
    .morebtn {
      color: $main-color;
    }
  }
}
</style>
